<template>
    <b-container fluid>
        <b-row>
            <b-col cols="4">
                <b-button block variant="primary" @click="openModalRiskDiagnosisForm"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Cargar diagnostico de riesgos</b-button>
            </b-col>
        </b-row>
        <app-risk-diagnosis-filters
            @filter="onFilter"
        />
        <app-risk-diagnosis-list
            :data="data"
            @change-page="changePage"
            @remove-risk-diagnosis="startRemove"
        />

        <!-- inicio de pop ups -->
            <app-pop-up
                id="risk-diagnosis-form-window"
                title="Subir archivos de diagnostico de riesgos"
                size="large"
            >
                <template slot="body">
                    <app-risk-diagnosis-form
                        :current-client="currentClient"
                        @success="onSuccess"
                        ref="riskDiagnosisForm"
                    ></app-risk-diagnosis-form>
                </template>
                <template slot="buttons">
                    <b-btn
                        id="btnSaveDiagnosis"
                        variant="primary"
                        @click="onSaveRiskDiagnosis"
                        :disabled="inProgress"
                        ><i class="fa fa-save"></i> Guardar</b-btn
                    >
                </template>
            </app-pop-up>

        <app-pop-up title="Confirmación" id="risk-diagnosis-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar este diagnostico de riesgo?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteRiskDiagnosis(riskDiagnosisId)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>
        </app-pop-up>
        <!-- fin de pop ups -->
    </b-container>
</template>
<script>
import appRiskDiagnosisForm from '../RiskDiagnosis/RiskDiagnosisForm'
import appRiskDiagnosisList from '../RiskDiagnosis/RiskDiagnosisList'
import appRiskDiagnosisFilters from '../RiskDiagnosis/RiskDiagnosisFilters'
export default {
    props: {
        theClient: {
            type: [Array, Object]
        }
    },
    components:{
        appRiskDiagnosisForm,
        appRiskDiagnosisList,
        appRiskDiagnosisFilters
    },
    data:() =>({
        page: 1,
        data: [],
        filters: null,
        riskDiagnosisId: '',
        currentClient: null
    }),
    methods: {
        onSuccess(data){
            toastr.success(data.msg)
            this.$bus.$emit('risk-diagnosis-form-window.close')
            this.loadRiskDiagnosis()
        },
        openModalRiskDiagnosisForm(){
            console.log(this.theClient)
            this.currentClient = this.theClient
            this.$bus.$emit('risk-diagnosis-form-window.open')
        },
        onFilter(filters){
            this.filters = filters
            this.loadRiskDiagnosis()
        },
        startRemove(id){
            this.riskDiagnosisId = id
            this.$bus.$emit('risk-diagnosis-remove.open')
        },
        onSaveRiskDiagnosis(){
            this.$refs.riskDiagnosisForm.saveRiskDiagnosis();
        },
        changePage(page){
            this.page = page;
            this.loadRiskAnalysis();
        },
        async deleteRiskDiagnosis(id){
            const { data } = await repo.delete(`risk-diagnosis/${id}`);
            this.data = data;

            if(data.status){
                this.$bus.$emit('risk-diagnosis-remove.close')
                toastr.success(data.msg)
                this.loadRiskDiagnosis()
            }else{
                toastr.error('Ocurrió un error al eliminar el archivo')
            }
        },
        async loadRiskDiagnosis(){
            try {
                const params = {
                    ...this.filters,
                    page: this.page,
                    with: 'reportedBy',
                    clientId: this.theClient.id,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir
                };
                const { data } = await repo.get("risk-diagnosis", params);
                this.data = data;
            } catch (err) {
                this.handleErrors(err);
            }
        }
    },
    mounted() {
        this.loadRiskDiagnosis()
    },
}
</script>